/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "us-west-2",
    "aws_cognito_identity_pool_id": "us-west-2:8b9072bd-4287-43fd-b8d5-d08bd1af810c",
    "aws_cognito_region": "us-west-2",
    "aws_user_pools_id": "us-west-2_qJPU4xXsY",
    "aws_user_pools_web_client_id": "5a14jc20nvn596rtjtpsdjrqlf",
    "oauth": {}
};


export default awsmobile;
